import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Results from './Results/';
import { TitleContainer } from './styles';

import './tabbar.css';

function TabContainer({ children }) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
});

class TabBar extends React.Component {
    handleFinancingSelector(value) {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(value);
    }


    render() {
        const {
            selectedFinancing,
            loanProvider,
            showPPA,
            showLoan,
            showOBS,
            showCAP,
            companyName,
            cashprice,
            resiToggle,
            includeCash,
            firstName,
            lastName,
            includeESS,
        } = this.props;

        let Loan = 'Solar Loan';
        if (loanProvider === 'mosaic') {
            Loan = 'Mosaic Solar Financing';
        }

        let name = companyName;
        if (resiToggle) {
            name = `${firstName} ${lastName}`;
        }


        return (
            <div className="tabbarContent">
                <AppBar
                    position="static"
                    color="default"
                    fullWidth
                >
                    <Tabs
                        value={selectedFinancing}
                        onChange={(event, value) => this.handleFinancingSelector(value)}
                        indicatorColor="secondary"
                        textColor="secondary"
                        fullWidth
                        centered
                    >
                        <Tab label="Incentives & System Specs" value={0} />
                        {showPPA && !resiToggle ? (<Tab label="PPA" value={1} />) : null }
                        {showLoan ?
                            (<Tab label={Loan} value={2} />) : null }
                        {showOBS && cashprice > 499999 ? (<Tab label="Solar Operating Lease" value={3} />) : null }
                        {showCAP && !resiToggle ? (<Tab label="Solar Capital Lease" value={5} />) : null }
                        {includeCash ? <Tab label="Solar Purchase" value={4} /> : null }
                        {!showPPA ? <Tab label="Compare Solar Financing" value={7} />
                            : null }
                        { includeESS ?
                            <Tab label="Add Batteries" value={6} />
                            : null }

                    </Tabs>
                </AppBar>
                {selectedFinancing > 0 && selectedFinancing !== 6 && (
                    <TitleContainer>
                        <p className="client-name">PV Financial Benefits for {name}</p>
                    </TitleContainer>
                )}
                <TabContainer>
                    <Results />
                </TabContainer>
            </div>
        );
    }
}

TabBar.propTypes = {
    selectedFinancing: PropTypes.number.isRequired,
    setSelectedFinancing: PropTypes.func.isRequired,
    loanProvider: PropTypes.string.isRequired,
    showPPA: PropTypes.bool.isRequired,
    showLoan: PropTypes.bool.isRequired,
    showOBS: PropTypes.bool.isRequired,
    showCAP: PropTypes.bool.isRequired,
    resiToggle: PropTypes.bool.isRequired,
    includeCash: PropTypes.bool.isRequired,
    includeESS: PropTypes.bool.isRequired,
    cashprice: PropTypes.number.isRequired,
    companyName: PropTypes.string,
    lastName: PropTypes.string,
    firstName: PropTypes.string,
};

TabBar.defaultProps = {
    companyName: 'our valued Customer',
    firstName: 'our valued Customer',
    lastName: null,
};

export default withStyles(styles, { withTheme: true })(TabBar);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/TabBar.js